<div class="flex flex-col h-full min-h-0">

    @if(canViewOrgTab) {

    <app-tabs-panels class="tabs-header-only flex-shrink-0" [tabs]="creditTabs" [activeTabValue]="activeTab"
        (tabChanged)="onTabChange($event)" />

    @if(activeTab === CREDIT_TAB.USER) {
    <ng-container *ngTemplateOutlet="userTabContent" />
    }

    @if(activeTab === CREDIT_TAB.ORG) {
    <div class="flex flex-col gap-4 p-4 overflow-y-auto flex-1 min-h-0">
        @if(orgAnalytics()) {
        <div class="flex flex-col gap-3">
            <div class="flex items-center justify-between">
                <span class="font-bold text-base">Overview</span>
                <div class="flex items-center gap-2 flex-shrink-0 flex-wrap">

                    <app-button [label]="selectedOrgModeLabel" variant="outlined" severity="contrast"
                        icon="chevron-down" iconPosition="right" iconSource="lucide"
                        (clicked)="orgModeMenu.toggle($event)" />

                    @if(isSuperAdmin) {
                    <app-button
                        [label]="orgSelectedUser === 'All' ? 'All Users' : (selectedOrgUserOption?.label ?? 'All Users')"
                        variant="outlined" severity="contrast" icon="chevron-down" iconPosition="right"
                        iconSource="lucide" (clicked)="orgUsersMenu.toggle($event)" />
                    }
                </div>
            </div>
            <div class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3">
                @for(card of orgOverviewCards(); track card.id) {
                <ng-container *ngTemplateOutlet="overviewCard; context: { card }"></ng-container>
                }
            </div>
        </div>
        }

        <div class="flex flex-col gap-3 flex-shrink-0">
            <div class="bg-surface-0 rounded-base border shadow-md overflow-hidden">
                <div class="px-4 pt-4 pb-2 flex items-center justify-between flex-wrap gap-2">
                    <div class="flex items-center gap-4">
                        <span class="font-bold text-base">Usage Trend</span>
                        @if(trendLoading()) {
                        <app-icon type="loader" source="lucide" size="sm" class="animate-spin text-surface-400" />
                        }
                    </div>
                    <div class="flex items-center gap-3">
                        <app-select-button [options]="trendPresetOptions" [(ngModel)]="trendPresetValue"
                            (ngModelChange)="onTrendPresetChange($event)"></app-select-button>
                        <app-datepicker [(ngModel)]="trendCustomDateRange" [config]="trendDatepickerConfig"
                            (ngModelChange)="onTrendDateRangeSelect($event)"></app-datepicker>
                    </div>
                </div>
                @if(trendData().length > 0) {
                <div class="px-4 pb-4">
                    <div echarts [options]="trendChartOption()" style="height: 280px; width: 100%;"></div>
                </div>
                } @else if(!trendLoading()) {
                <div class="px-4 pb-10 pt-6 flex flex-col items-center justify-center gap-2 text-surface-400">
                    <app-icon type="bar-chart-2" source="lucide" size="lg" />
                    <span class="text-sm">No usage data for the selected period</span>
                </div>
                }
            </div>
        </div>

        @if(hasAlerts) {
        <div class="flex flex-col gap-3">
            <span class="font-bold text-base flex items-center gap-2">
                Limit Alerts
            </span>
            <app-data-table [data]="allAlertRows()" [columns]="alertColumns" [customTemplates]="alertTemplatesMap" />
        </div>
        }

    </div>
    }

    } @else {
    <ng-container *ngTemplateOutlet="userTabContent" />
    }
</div>


<app-menu #usersMenu [items]="userMenuItems" [selectedValues]="selectedUserMenuData"
    (itemSelected)="onUserSelected($event)" [search]="true" [itemTemplate]="userItemTemplate" />

<app-menu #orgModeMenu [items]="orgModeMenuItems" [selectedValues]="selectedOrgModeData"
    (itemSelected)="onOrgModeSelected($event)" />

<app-menu #orgUsersMenu [items]="orgUserMenuItems" [selectedValues]="selectedOrgUserData"
    (itemSelected)="onOrgUserSelected($event)" [search]="true" [itemTemplate]="userItemTemplate" />

<app-credits-checkout-dialog [(visible)]="checkoutDialogVisible" [checkoutItems]="checkoutItems"
    [successUrl]="checkoutSuccessUrl" [cancelUrl]="checkoutCancelUrl" [source]="CHECKOUT_SESSION_TYPE.ADD_CREDITS" />


<ng-template #userTabContent>
    <div class="flex flex-col flex-1 min-h-0">

        <div class="flex flex-wrap justify-between items-center gap-3 flex-shrink-0 px-4 py-2">
            <div class="flex gap-2 items-center flex-wrap">
                <app-button label="Get Credits" variant="filled" severity="primary"
                    (clicked)="creditsOverviewRef?.openRequestDialog()" />
                @if(canAddCredits) {
                <app-button label="Add Credits" variant="filled" severity="default"
                    (clicked)="openAddCreditsDialog()" />
                }
            </div>
            <div class="flex items-center gap-3 flex-wrap">
                @if(isSuperAdmin) {
                <div class="flex items-center gap-2 cursor-pointer border border-gray-200 rounded-base pt-1 px-1 bg-surface-0 hover:bg-surface-50 transition-colors"
                    (click)="usersMenu.toggle($event)">
                    <app-user-name-display [user]="selectedUserOption?.data" variant="avatar-name" size="sm" />
                    <app-icon type="chevron-down" source="lucide" size="sm" class="text-surface-400 pb-1" />
                </div>
                }
                <app-select-button [options]="filterOptions" [(ngModel)]="selectedFilter"
                    (ngModelChange)="onFilterChange()"></app-select-button>
            </div>
        </div>

        <div class="flex flex-col gap-4 px-4 pb-4 overflow-y-auto flex-1 min-h-0">
            <app-credits-overview #creditsOverviewRef [credits]="userCredits" [needHeader]="false" [variant]="'cards'"
                [needActionButtons]="false" [filter]="selectedFilter" />

            <div class="flex flex-col gap-2">
                <div class="flex items-center justify-between">
                    <span class="font-bold text-base">Usage Records</span>
                    <span class="text-xs text-surface-400">{{ filteredData.length }} records</span>
                </div>
                <app-data-table [data]="filteredData" [columns]="columns" [customTemplates]="customTemplatesMap" />
            </div>
        </div>

    </div>
</ng-template>

<ng-template #dateCellRef let-row="$implicit">
    <span class="text-sm text-gray-700">{{ row.createdAt | date:'MMM d, yyyy, h:mm a' }}</span>
</ng-template>

<ng-template #modeCellRef let-row="$implicit">
    @if (row.creditType?.toLowerCase() === 'ask') {
    <span class="inline-flex items-center gap-1 px-2.5 py-1 rounded-md text-xs font-medium bg-arena-orange-100">
        <app-icon type="zap" source="lucide" size="sm" />
        Ask
    </span>
    } @else if (row.creditType?.toLowerCase() === 'agent') {
    <span class="inline-flex items-center gap-1 px-2.5 py-1 rounded-md text-xs font-medium bg-arena-blue-100">
        <app-icon [type]="CREDITS_SVG.AGENT_MODE" source="svg" size="sm" />
        Agent
    </span>
    } @else {
    <span class="text-sm text-gray-500">{{ row.creditType || '—' }}</span>
    }
</ng-template>

<ng-template #featureCellRef let-row="$implicit">
    <span class="text-sm font-medium truncate">{{ row.feature || '—' }}</span>
</ng-template>

<ng-template #detailsCellRef let-row="$implicit">
    <span class="text-sm text-gray-700 truncate" [title]="row.details">{{ row.details || '—' }}</span>
</ng-template>

<ng-template #userItemTemplate let-option>
    @if(option.data) {
    <app-user-name-display [user]="option.data" variant="avatar-name" size="sm" />
    } @else {
    <span class="text-sm font-medium">{{ option.label }}</span>
    }
</ng-template>

<ng-template #alertUserCellRef let-row="$implicit">
    <div class="flex flex-col gap-0.5 min-w-0">
        <app-user-name-display [user]="row.user" variant="avatar-name" size="sm" />
    </div>
</ng-template>

<ng-template #alertModeCellRef let-row="$implicit">
    @if(row.type === 'ASK') {
    <span class="inline-flex items-center gap-1 px-2.5 py-1 rounded-md text-xs font-medium bg-arena-orange-100">
        <app-icon type="zap" source="lucide" size="sm" />
        Ask
    </span>
    } @else {
    <span class="inline-flex items-center gap-1 px-2.5 py-1 rounded-md text-xs font-medium bg-arena-blue-100">
        <app-icon [type]="CREDITS_SVG.AGENT_MODE" source="svg" size="sm" />
        Agent
    </span>
    }
</ng-template>

<ng-template #alertUsageCellRef let-row="$implicit">
    <div class="flex flex-col gap-1">
        <div class="flex items-center justify-between text-xs gap-4">
            <span class="text-surface-500">{{ row.consumed | number:'1.0-0' }} / {{ row.allocated | number:'1.0-0'
                }}</span>
            <span class="font-semibold flex-shrink-0" [class.text-red-600]="row.status === 'negative'"
                [class.text-orange-600]="row.status === 'blocked'" [class.text-amber-600]="row.status === 'near-limit'">
                {{ row.pct }}%
            </span>
        </div>
        <div class="h-1.5 bg-gray-100 rounded-full overflow-hidden">
            <div class="h-full rounded-full transition-all" [class.bg-red-500]="row.status === 'negative'"
                [class.bg-orange-500]="row.status === 'blocked'" [class.bg-amber-400]="row.status === 'near-limit'"
                [style.width.%]="row.status === 'negative' ? 100 : row.pct"></div>
        </div>
    </div>
</ng-template>

<ng-template #overviewCard let-card="card">
    <div class="bg-surface-0 rounded-base shadow-md border overflow-hidden flex flex-col">
        <!-- <div class="h-1" [ngClass]="card.borderColor"></div> -->
        <div class="p-4 flex flex-col gap-1 flex-1">
            <span class="text-xs text-surface-400  tracking-wide">{{ card.title }}</span>
            <div class="flex items-end justify-between gap-1 mt-0.5">
                <span class="text-2xl font-bold" [ngClass]="card.valueColor">
                    {{ card.value | number:'1.0-0' }}{{ card.suffix || '' }}
                </span>
                @if(card.secondaryValue !== undefined) {
                <div class="flex items-baseline gap-1">
                    <span class="text-lg text-surface-400 font-medium">/ {{ card.secondaryValue | number:'1.0-0'
                        }}</span>
                </div>
                }
                <!-- @else {
                <span class="text-sm font-semibold" [ngClass]="card.percentColor">{{ card.percentage }}%</span>
                }  -->
            </div>
            <span class="text-xs text-surface-400">{{ card.subtitle }}</span>
            <div class="h-1.5 bg-gray-100 rounded-full mt-2 overflow-hidden">
                <div class="h-full rounded-full transition-all" [ngClass]="card.barColor"
                    [style.width.%]="card.barPercentage || card.percentage"></div>
            </div>
        </div>
    </div>
</ng-template>